<template>
  <v-container grid-list-xl fluid>

    <FabricSelector title="Shutter Type" :value="item.fabric" :fabricGroupID="selectedFabricGroup" v-on:selected-fabric="selectedFabric = $event" :v="$v.item.fabric" :error="$v.item.fabric.$error"></FabricSelector>

    <ColorSelector :fabricID="selectedFabric" :value="item.color" v-on:selected-color="selectedColor = $event" :v="$v.item.color" :error="$v.item.color.$error"></ColorSelector>

    <DimensionSelector v-on:room="setRoom($event)" :valueName="item.name" :valueWidth="item.width" :valueDrop="item.drop" ref="dimensionSelector" @ready="isReady => readyToSubmitDimension = isReady" :type="this.item.type"></DimensionSelector>

    <CustomizationSelector title="Fitting" :value="item.variations.fitting" :options="['Face', 'Recess']" v-on:selected-option="item.variations.fitting = $event, changeFrameOptions($event)" :v="$v.item.variations.fitting" :error="$v.item.variations.fitting.$error"></CustomizationSelector>

    <CustomizationSelector title="Frame" :value="item.variations.frame" :options="frameOptions" v-on:selected-option="item.variations.frame = $event, $event === 'No Frame' ? item.variations.frameType = null : ''" :v="$v.item.variations.frame" :error="$v.item.variations.frame.$error"></CustomizationSelector>

    <CustomizationSelector v-if="item.variations.frame == 'Full Frame' || item.variations.frame == '3 Sided Frame'" title="Frame Design" :value="item.variations.frameType" :options="frameDesigns" v-on:selected-option="item.variations.frameType = $event" :v="$v.item.variations.frameType" :error="$v.item.variations.frameType.$error"></CustomizationSelector>

    <CustomizationSelector title="Midrail" :value="item.variations.rail" :options="item.drop < 1600 ? ['No Rail', 'Single Rail', 'Double Rail'] : ['Single Rail', 'Double Rail']" v-on:selected-option="item.variations.rail = $event, resetMidRailHeight($event)" :v="$v.item.variations.rail" :error="$v.item.variations.rail.$error"></CustomizationSelector>

    <CustomizationSelector title="Panel Count" :value="item.variations.panel" :options="['1 Panel', '2 Panels', '3 Panels', '4 Panels', '6 Panels']" v-on:selected-option="item.variations.panel = $event, resetpanelWidths()" :v="$v.item.variations.panel" :error="$v.item.variations.panel.$error"></CustomizationSelector>

    <CustomizationSelector title="Panel Combination" :value="item.variations.panelCombination" :options="panelCombinations" v-on:selected-option="item.variations.panelCombination = $event, resetTPostMeasurements()" :v="$v.item.variations.panelCombination" :error="$v.item.variations.panelCombination.$error"></CustomizationSelector>

    <CustomizationSelector title="Hinge Colour" :value="item.variations.hingeColor" :options="['White', 'Beige', 'Chrome', 'Anodised Silver']" v-on:selected-option="item.variations.hingeColor = $event" :v="$v.item.variations.hingeColor" :error="$v.item.variations.hingeColor.$error"></CustomizationSelector>

    <div v-if="incInstall">
      <v-checkbox label="Install?" color="primary" v-model="customInstall"></v-checkbox>
      <v-text-field v-if="customInstall" label="Install Price" v-model="item.installPrice"></v-text-field>
    </div>

    <CustomizationSelector v-if="['Single Rail', 'Double Rail'].includes(item.variations.rail)" title="Midrail Alignment" :value="item.variations.railAlignment" :options="['Even Alignment', 'Uneven Alignment']" v-on:selected-option="item.variations.railAlignment = $event, resetMidRailHeight()" :v="$v.item.variations.railAlignment" :error="$v.item.variations.railAlignment.$error"></CustomizationSelector>
    <v-layout row wrap v-if="item.variations.railAlignment === 'Uneven Alignment'">
      <v-flex xs12>
        <h4>Midrail Measurement</h4>
      </v-flex>
      <v-flex xs12 sm6>
        <div v-if="railMeasurementErr && !item.variations.railMeasurement[0]" class="red--text">Please enter Midrail Height 1</div>
        <v-text-field label="A" v-model="item.variations.railMeasurement[0]"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 v-if="item.variations.rail === 'Double Rail'">
        <div v-if="railMeasurementErr && !item.variations.railMeasurement[1]" class="red--text">Please enter Midrail Height 2</div>
        <v-text-field label="B" v-model="item.variations.railMeasurement[1]"></v-text-field>
      </v-flex>
    </v-layout>

    <CustomizationSelector v-if="['3 Panels', '4 Panels', '6 Panels'].includes(item.variations.panel)" title="Panel Widths" :value="item.variations.panelWidths" :options="['Even Panels', 'Custom Panels']" v-on:selected-option="item.variations.panelWidths = $event, resetTPostMeasurements()" :v="$v.item.variations.panelWidths" :error="$v.item.variations.panelWidths.$error"></CustomizationSelector>
    <v-layout row wrap v-if="item.variations.panelWidths === 'Custom Panels'">
      <!-- <v-flex xs12>
        <h4>T Post Measurements</h4>
      </v-flex>
      <v-flex xs12 sm6>
        <div v-if="$v.item.variations.tPostMeasurement1.$error" class="red--text">Please select T Post Measurement 1</div>
        <v-text-field label="Measurement 1" v-model="item.variations.tPostMeasurement1" :v="$v.item.variations.tPostMeasurement1"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 v-if="item.variations.panelCombination !== null && (item.variations.panelCombination.match(/T Post/g) || []).length === 2">
        <div v-if="$v.item.variations.tPostMeasurement2.$error" class="red--text">Please select T Post Measurement 2</div>
        <v-text-field label="Measurement 2" v-model="item.variations.tPostMeasurement2" :v="$v.item.variations.tPostMeasurement2"></v-text-field>
      </v-flex> -->
      <v-flex xs12>
        <h4>T Post Measurements</h4>
      </v-flex>
      <v-flex xs12 sm6>
        <div v-if="panelMeasurementsErr && !item.variations.panelMeasurements[0]" class="red--text">Please enter T Post Measurement 1</div>
        <v-text-field label="A" v-model="item.variations.panelMeasurements[0]"></v-text-field>
      </v-flex>
      <v-flex xs12 sm6 v-if="(item.variations.panelCombination.match(/T Post/g) || []).length === 2">
        <div v-if="panelMeasurementsErr && !item.variations.panelMeasurements[1]" class="red--text">Please enter T Post Measurement 2</div>
        <v-text-field label="B" v-model="item.variations.panelMeasurements[1]"></v-text-field>
      </v-flex>
    </v-layout>

    <!-- <v-checkbox label="Motorized?" color="primary" v-model="motorized"></v-checkbox>
    <v-select v-if="motorized" @change="motorActions" v-model="item.motor" :items="[{ text: 'SOMFY - Sonesse 30 Li-ion'},{ text: 'SOMFY - Altus 28 Li-ion'},{ text: 'SOMFY - Altus 40 RTS - wired'},{ text: 'SOMFY - Sonesse 40 30/30 - wired'},{ text: 'ACMEDA - AUTOMATE | Li-ion 1.1'}, { text: 'ACMEDA - AUTOMATE | Li-ion 3.0'}, { text: 'ACMEDA - AUTOMATE | E6 - wired'}]" label="Motor"></v-select>
    <v-text-field v-if="motorized" label="Motor Price" v-model="item.motorPrice" readonly></v-text-field> -->
    <v-textarea name="notes" label="Line Item Notes" v-model="item.notes"></v-textarea>
    <v-btn v-if="!edit" @click="addItem()" color="primary">Add {{ item.type }}</v-btn>
    <v-btn v-else @click="addItem()" color="primary">Update {{ item.type }}</v-btn>
    <b>${{ (item.total).toFixed(2) }}</b>
  </v-container>
</template>

<script>
import FabricGroupService from '@/services/FabricGroupService.js'
import FabricSelector from '@/components/parts/FabricSelector'
import ColorSelector from '@/components/parts/ColorSelector'
import DimensionSelector from '@/components/parts/DimensionSelector'
import CustomizationSelector from '@/components/parts/CustomizationSelector'

import ItemService from '@/services/ItemService'
import { required, requiredIf } from 'vuelidate/lib/validators'
// import { isArray } from 'util'

const gConfig = require('../../../gConfig.json')

export default {
  props: {
    edittingItem: {
      default: null
    },
    editChange: {
      default: null
    }
  },
  components: {
    FabricSelector,
    ColorSelector,
    DimensionSelector,
    CustomizationSelector
  },
  data () {
    return {
      selectedFabricGroup: null,
      fabricGroups: [],
      colors: [],
      pelmetToggle: null,
      selectedFabric: null,
      selectedColor: null,
      customInstall: false,
      motorized: false,
      readyToSubmitDimension: false,
      edit: false,
      railMeasurementErr: false,
      panelMeasurementsErr: false,
      frameOptions: ['Full Frame', '3 Sided Frame', 'No Frame'],
      item: {
        type: 'Shutter',
        fabric: null,
        color: null,
        name: null,
        width: null,
        drop: null,
        total: 0,
        orderID: null,
        installPrice: 0,
        motor: null,
        motorPrice: 0,
        notes: null,
        variations: {
          fitting: null,
          frame: null,
          frameType: null,
          rail: null,
          panel: null,
          panelCombination: null,
          hingeColor: null,
          railAlignment: null,
          railMeasurement: [],
          panelWidths: null,
          panelMeasurements: []
        }
      },
      incInstall: gConfig.install
    }
  },
  validations: {
    item: {
      fabric: { required },
      color: { required },
      name: { required },
      drop: { required },
      width: { required },
      variations: {
        fitting: { required },
        frame: { required },
        frameType: { required: requiredIf(function () { return this.item.variations.frame !== 'No Frame' }) },
        rail: { required },
        panel: { required },
        panelCombination: { required },
        hingeColor: { required },
        railAlignment: { required: requiredIf(function () { return (this.item.drop >= 1500 && (this.item.variations.rail === 'Single Rail' || this.item.variations.rail === 'Double Rail')) }) },
        // railMeasurement[0]: { required: requiredIf(function () { return (this.item.drop >= 1500 && this.item.variations.railAlignment === 'Uneven Alignment') }) },
        // railMeasurement[1]: { required: requiredIf(function () { return (this.item.drop >= 1500 && this.item.variations.railAlignment === 'Uneven Alignment') && this.item.variations.rail === 'Double Rail' }) },
        panelWidths: { required: requiredIf(function () { return ['3 Panels', '4 Panels', '6 Panels'].includes(this.item.variations.panel) }) }
        // tPostMeasurement1: { required: requiredIf(function () { return this.item.variations.panelWidths === 'Custom Panels' }) },
        // tPostMeasurement2: { required: requiredIf(function () { return this.item.variations.panelWidths === 'Custom Panels' && (this.item.variations.panelCombination.match(/T Post/g) || []).length === 2 }) }
      }
    }
  },
  watch: {
    item: {
      handler (item) {
        this.getPrice(item)
      },
      deep: true
    },
    edittingItem (item) {
      this.useEdittingItem(item)
    },
    selectedFabric (val) {
      this.item.fabric = val
    },
    selectedColor (val) {
      this.item.color = val
    },
    motorized (val) {
      if (!val) {
        this.item.motor = null
        this.item.motorPrice = 0
      }
    },
    customInstall (val) {
      if (!val) {
        this.item.installPrice = 0
      }
    }
  },
  mounted () {
    this.getFabricGroups()
    this.useEdittingItem(this.edittingItem)
  },
  computed: {
    panelCounts () {
      var panelCounts = []
      return panelCounts
    },
    panelCombinations () {
      var panelCombinations = []
      switch (this.item.variations.panel) {
        case '1 Panel':
          panelCombinations = ['Left', 'Right']
          break
        case '2 Panels':
          panelCombinations = ['Left-Right', 'Left(D) - Right', 'Left T Post Right']
          break
        case '3 Panels':
          panelCombinations = ['Left-Right T Post Right', 'Left T Post Left-Right', 'Right T Post Right T Post Right', 'Left T Post Left T Post Left', 'Left T Post Left T Post Right', 'Left T Post Right T Post Right']
          break
        case '4 Panels':
          panelCombinations = ['Left-Right T Post Left-Right', 'Left T Post Left-Right T Post Right']
          break
        case '6 Panels':
          panelCombinations = ['Left-Right T Post Left-Right T Post Left-Right']
          break
      }
      return panelCombinations
    },
    frameDesigns () {
      var frameDesigns = []
      switch (this.item.variations.frame) {
        case 'Full Frame':
          frameDesigns = ['Small L Frame', 'Medium L Frame', 'Z Frame', 'Z Frame with sill']
          break
        case '3 Sided Frame':
          frameDesigns = ['Small L Frame', 'Medium L Frame', 'Z Frame']
          break
      }

      return frameDesigns
    }
  },
  methods: {
    async getPrice (item) {
      const response = await ItemService.getPricing(item)
      if (response.data.price) {
        this.item.total = response.data.price
      }
    },

    async getFabricGroups () {
      const response = await FabricGroupService.getFabricGroupsByType(this.item.type)
      this.fabricGroups = response.data
      this.selectedFabricGroup = this.fabricGroups[0]._id
    },

    setRoom (room) {
      this.item.width = room.width
      this.item.drop = room.drop
      this.item.name = room.name
    },

    addItem () {
      this.$refs.dimensionSelector.touch()
      this.$v.item.$touch()
      if (this.$v.item.$pending || this.$v.item.$error || !this.readyToSubmitDimension) return

      if ((this.item.drop >= 1500 && this.item.variations.railAlignment === 'Uneven Alignment') && !this.item.variations.railMeasurement[0]) {
        this.railMeasurementErr = true
        return
      }
      if ((this.item.drop >= 1500 && this.item.variations.railAlignment === 'Uneven Alignment') && this.item.variations.rail === 'Double Rail' && !this.item.variations.railMeasurement[1]) {
        this.railMeasurementErr = true
        return
      }
      if (this.item.variations.panelWidths === 'Custom Panels' && !this.item.variations.panelMeasurements[0]) {
        this.panelMeasurementsErr = true
        return
      }
      if (this.item.variations.panelWidths === 'Custom Panels' && (this.item.variations.panelCombination.match(/T Post/g) || []).length === 2 && !this.item.variations.panelMeasurements[1]) {
        this.panelMeasurementsErr = true
        return
      }

      this.edit = false
      this.$emit('create-item', this.item)
    },

    async motorActions (value) {
      switch (value) {
        case 'SOMFY - Sonesse 30 Li-ion':
          this.item.motorPrice = 295
          break
        case 'SOMFY - Altus 28 Li-ion':
          this.item.motorPrice = 210
          break
        case 'SOMFY - Altus 40 RTS - wired':
          this.item.motorPrice = 265
          break
        case 'SOMFY - Sonesse 40 30/30 - wired':
          this.item.motorPrice = 380
          break
        case 'ACMEDA - AUTOMATE | Li-ion 1.1':
          this.item.motorPrice = 250
          break
        case 'ACMEDA - AUTOMATE | Li-ion 3.0':
          this.item.motorPrice = 350
          break
        case 'ACMEDA - AUTOMATE | E6 - wired':
          this.item.motorPrice = 199
          break
      }
    },

    useEdittingItem (item) {
      if (!this.editChange) {
        if (item) {
          this.edit = true
          this.item = item
          this.selectedFabricGroup = (item.fabric.group._id ? item.fabric.group._id : item.fabric.group)
          this.selectedFabric = (item.fabric._id ? item.fabric._id : item.fabric)
          this.item.color = (item.color._id ? item.color._id : item.color)
          this.motorized = parseInt(item.motorPrice) > 0
          this.customInstall = parseInt(item.installPrice) > 0

          // old naming to new naming on edit can be deleted after 01/07/2021 (approx 6 months)
          if (item.variations.midrailAllignment) {
            this.item.variations.railAlignment = item.variations.midrailAllignment
            switch (this.item.variations.railAlignment) {
              case 'Even':
                this.item.variations.railAlignment = 'Even Alignment'
                break
              case 'Custom':
                this.item.variations.railAlignment = 'Uneven Alignment'
                break
            }
          }
          if (!Array.isArray(this.item.variations.railMeasurement)) {
            this.item.variations.railMeasurement = []
          }
          if (item.variations.midrailHeight1) {
            this.item.variations.railMeasurement.push(item.variations.midrailHeight1)
          }
          if (item.variations.midrailHeight2) {
            this.item.variations.railMeasurement.push(item.variations.midrailHeight2)
          }

          if (item.variations.tPostDimension) {
            this.item.variations.panelWidths = item.variations.tPostDimension
            switch (this.item.variations.panelWidths) {
              case 'Even':
                this.item.variations.panelWidths = 'Even Panels'
                break
              case 'Custom':
                this.item.variations.panelWidths = 'Custom Panels'
                break
            }
          }
          if (!Array.isArray(this.item.variations.panelMeasurements)) {
            this.item.variations.panelMeasurements = []
          }
          if (item.variations.tPostMeasurement1) {
            this.item.variations.panelMeasurements.push(item.variations.tPostMeasurement1)
          }
          if (item.variations.tPostMeasurement2) {
            this.item.variations.panelMeasurements.push(item.variations.tPostMeasurement2)
          }
          // no need old naming variations
          delete this.item.variations.midrailAllignment
          delete this.item.variations.midrailHeight1
          delete this.item.variations.midrailHeight2
          delete this.item.variations.tPostDimension
          delete this.item.variations.tPostMeasurement1
          delete this.item.variations.tPostMeasurement2
          // old naming to new naming on edit can be deleted after 01/07/2021 (approx 6 months)

          // for editing online orders
          if (this.item.variations.fitting) {
            switch (this.item.variations.fitting) {
              case 'Face Fit':
                this.item.variations.fitting = 'Face'
                break
              case 'Recess Fit':
                this.item.variations.fitting = 'Recess'
                break
            }
          }
          if (this.item.variations.panelCombination) {
            this.item.variations.panelCombination = this.item.variations.panelCombination.replace(/,/g, '').replace(/T-Post/g, 'T Post')
          }
          // for editing online orders
        }
      } else {
        this.item = {
          type: 'Shutter',
          fabric: null,
          color: null,
          name: null,
          width: null,
          drop: null,
          total: 0,
          orderID: null,
          installPrice: 0,
          motor: null,
          motorPrice: 0,
          notes: null,
          variations: {
            fitting: null,
            frame: null,
            frameType: null,
            rail: null,
            panel: null,
            panelCombination: null,
            hingeColor: null,
            railAlignment: null,
            railMeasurement: [],
            panelWidths: null,
            panelMeasurements: []
            // tPostMeasurement1: null,
            // tPostMeasurement2: null
          }
        }
        this.item._id = item._id
        this.item.name = item.name
        this.item.width = item.width
        this.item.drop = item.drop
        this.item.orderID = item.orderID
      }
    },
    resetMidrailAlignment () {
      this.item.variations.railAlignment = null
      this.resetMidRailHeight()
    },
    resetMidRailHeight (value = null) {
      if (value === null) {
        value = this.item.variations.rail
      }
      if (this.item.variations && this.item.variations.railAlignment === 'Even Alignment') {
        // this.item.variations.railMeasurement[0] = null
        // this.item.variations.railMeasurement[1] = null
        this.item.variations.railMeasurement = []
      }
      if (value === 'No Rail') {
        this.item.variations.railMeasurement = []
        // this.item.variations.railMeasurement[0] = null
        // this.item.variations.railMeasurement[1] = null
        this.item.variations.railAlignment = null
      } else if (value === 'Single Rail') {
        this.item.variations.railMeasurement = []
        // this.item.variations.railMeasurement[1] = null
      }
    },
    resetpanelWidths () {
      this.item.variations.panelWidths = null
      this.resetTPostMeasurements()
    },
    resetTPostMeasurements () {
      this.item.variations.panelMeasurements = []
    },
    changeFrameOptions (value) {
      if (value === 'Face') {
        this.frameOptions = ['Full Frame', '3 Sided Frame']
      } else {
        this.frameOptions = ['Full Frame', '3 Sided Frame', 'No Frame']
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/products/Shutter.vue